// CSV helpers. `toCsv` is pure (testable); `downloadCsv` touches the DOM.

function escapeCell(v) {
  const s = v == null ? "" : String(v);
  // RFC 4180: quote if the cell has a comma, quote, CR or LF; double internal quotes.
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

// rows: array of arrays (first row = header). Returns CSV text (CRLF-joined).
export function toCsv(rows) {
  return rows.map((r) => r.map(escapeCell).join(",")).join("\r\n");
}

// rows → 탭 구분 텍스트(TSV). 클립보드에 복사해서 노션/구글시트/엑셀에 붙여넣으면
// 표로 인식된다(2026-07-18 — "노션에 붙여넣기 편하게" 피드백). 셀 안의 탭/줄바꿈은
// 표 구조를 깨뜨리므로 공백으로 치환.
export function toTsv(rows) {
  return rows
    .map((r) => r.map((v) => (v == null ? "" : String(v).replace(/[\t\r\n]+/g, " "))).join("\t"))
    .join("\n");
}

// Trigger a browser download of `rows` as `filename`.
export function downloadCsv(filename, rows) {
  const csv = toCsv(rows);
  // Prepend a BOM (U+FEFF) so Excel reads UTF-8 (한글) correctly.
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
